import z from 'zod';

import {
    CURRENT_VERSION,
    ElementId,
    emptyChildren,
    EmptyChildren,
    UnityElementId,
    Version,
} from '../commons';
import { ELEMENT_TYPES } from '../constants';

export const UnitySeparator = z.object({
    type: z.literal(ELEMENT_TYPES.SEPARATOR),
    elementId: UnityElementId,
    templateElement: z.boolean().optional(),
    version: Version,
});
export type UnitySeparator = z.infer<typeof UnitySeparator>;

export const PlateSeparator = z.object({
    type: z.literal(ELEMENT_TYPES.SEPARATOR),
    id: ElementId,
    data: z
        .object({
            templateElement: z.boolean().optional(),
        })
        .optional(),
    children: EmptyChildren,
});
export type SeparatorElement = z.infer<typeof PlateSeparator>;

export const SeparatorCodec = z.codec(UnitySeparator, PlateSeparator, {
    decode: (value) => ({
        type: value.type,
        id: value.elementId ?? crypto.randomUUID(),
        ...(value.templateElement ? { data: { templateElement: value.templateElement } } : {}),
        children: emptyChildren,
    }),
    encode: (value) => ({
        type: value.type,
        elementId: value.id,
        version: CURRENT_VERSION,
        ...value.data,
    }),
});
